// カタカナのみ許可する正規表現
export const KATAKANA_ONLY = /^[ァ-ヶー－]+$/;
